import { render, staticRenderFns } from "./NaverPayAmountDetail.vue?vue&type=template&id=f595eef2&"
import script from "./NaverPayAmountDetail.vue?vue&type=script&lang=ts&"
export * from "./NaverPayAmountDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports